const fancySub = ($fancySub) => {
  const account_id = $fancySub.getAttribute('account-id')
  const guide_id = $fancySub.getAttribute('guide-id')
  const reference = $fancySub.getAttribute('reference')
  const sub_account_id = $fancySub.getAttribute('sub-account-id')
  const $account_id = document.querySelector('[name="account_id"]')
  const $guide_id = document.querySelector('[name="guide_id"]')
  const $reference = document.querySelector('[name="reference"]')
  const $sub_account_id = document.querySelector('[name="sub_account_id"]')
  const $optionExist = $sub_account_id.querySelector('option[value="' + sub_account_id + '"]')

  if ($account_id)
    $account_id.value = account_id

  if ($guide_id)
    $guide_id.value = guide_id

  if ($reference) {
    $reference.value = reference
    $reference.dispatchEvent(new Event('change'))
  }

  $sub_account_id.querySelectorAll('option').forEach(($option) => {
    $option.removeAttribute('selected')
  })

  if ($optionExist) {
    $optionExist.setAttribute('selected', true)
  } else {
    $sub_account_id.selectedIndex = 0
  }

  $sub_account_id.dispatchEvent(new CustomEvent('change'))
}
const subAccountValidation = () => {
  const $subId  = document.querySelector('[name="sub_account_id"]')
  const $newSub = document.querySelector('[name="new_subaccount"]')
  const $fancySubs = document.querySelectorAll('a[sub-account-id]')

  if ($fancySubs.length > 0) {
    $fancySubs.forEach(($fancySub) => {
      $fancySub.addEventListener('click', (e) => {
        if (e.target.tagName === 'A' || e.target.tagName === 'a') {
          fancySub(e.target)
        } else {
          fancySub(e.target.closest('a'))
        }
      })
    })
  }

  if (!$subId || !$newSub)
    return false

  $subId.addEventListener('change', (e) => {
    if ($subId.value === "")
      return false

    $newSub.value = ""
    $newSub.dispatchEvent(new CustomEvent('change'))
  })

  $newSub.addEventListener('change', (e) => {
    if ($newSub.value === "")
      return false

    $subId.selectedIndex = 0
    $subId.dispatchEvent(new CustomEvent('change'))
  })
}

export default subAccountValidation
